/* Product order is an input. Complete rows take precedence over local position. */
(function () {
  'use strict';
  function planEditorial(source) {
    const pending = source.slice(), groups = [];
    let featureCount = 0;
    const take = (items) => { for (const item of items) pending.splice(pending.indexOf(item), 1); };
    while (pending.length) {
      if (pending[0].kind === 'study') {
        // Separate adjacent colour studies when ordinary products are available nearby.
        const neighbours = pending.slice(1, 10).filter(x => x.kind === 'regular');
        if (groups.at(-1)?.kind === 'study' && neighbours.length >= 2) {
          const items = neighbours.slice(0, 4); take(items); groups.push({kind:'regular',items});
        } else { groups.push({kind:'study',items:[pending.shift()]}); }
        continue;
      }
      const boundary = pending.findIndex(x => x.kind === 'study');
      const local = pending.slice(0, boundary < 0 ? pending.length : boundary);
      const featured = local.slice(0, 4).find(x => x.kind === 'feature');
      if (featured) {
        const normals = pending.slice(0, 10).filter(x => x.kind === 'regular').slice(0, 4);
        if (normals.length === 4) {
          const items = [normals[0], normals[1], featured, normals[2], normals[3]];
          take(items); groups.push({kind:'feature',side:featureCount++ % 2 ? 'right':'left',items}); continue;
        }
      }
      // A feature without enough companions uses an ordinary card, so it cannot leave holes.
      const items = local.slice(0, 4);
      if (items.length < 4 && boundary >= 0) {
        const fill = pending.slice(boundary + 1, 10).filter(x => x.kind === 'regular').slice(0, 4-items.length);
        items.push(...fill);
      }
      take(items); groups.push({kind:'regular',items});
    }
    return groups;
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = {planEditorial};
  if (typeof document === 'undefined') return;
  if (window.leSevenFeaturedEditorialInitialized) return;
  window.leSevenFeaturedEditorialInitialized = true;
  const state = new WeakMap(); let scheduled = false, customerSort = false;
  const motion = new IntersectionObserver(entries => entries.forEach(e => e.target.classList.toggle('le-in-view',e.isIntersecting)),{threshold:.08});
  const plainRequested = () => {
    const query = new URLSearchParams(location.search);
    return customerSort || query.has('sort_by') || [...query].some(([key,value]) => value && (key.startsWith('filter.') || ['le_shape','le_size','le_polarization'].includes(key))) || !!document.querySelector('[data-le-seven-filter-input]:checked');
  };
  function refresh() {
    scheduled = false;
    const grid = document.querySelector('[data-le-editorial-grid]'); if (!grid) return;
    const flat = [...grid.querySelectorAll('li[data-editorial-kind][data-product-id]')];
    const previous = state.get(grid);
    const same = previous && flat.length === previous.source.length && flat.every(node => previous.source.includes(node));
    const source = same ? previous.source : flat;
    const mode = grid.dataset.editorialAllowed === 'true' && !plainRequested() ? 'editorial' : 'plain';
    if (same && previous.mode === mode) return;
    motion.disconnect();
    for (const node of source) {
      node.classList.remove('le-model-feature','le-colour-slot','scroll-trigger','animate--slide-in');
      node.style.removeProperty('--animation-order');
      node.querySelector('.le-standard-card').hidden = false;
      const study = node.querySelector('.le-study-content'); if (study) study.hidden = true;
      node.querySelectorAll('.le-motion-photo').forEach(img => img.classList.remove('le-motion-photo'));
      node.querySelectorAll('img[data-le-original-sizes]').forEach(img => {img.sizes=img.dataset.leOriginalSizes;delete img.dataset.leOriginalSizes;});
    }
    grid.dataset.layoutMode = mode;
    if (mode === 'plain') grid.replaceChildren(...source);
    else {
      const fragments = document.createDocumentFragment();
      // Review a proposed order without changing the collection in Shopify.
      const preferred = (grid.dataset.editorialOrder || '').split(',').map(x => x.trim()).filter(Boolean);
      const positions = new Map(preferred.map((handle,index) => [handle,index]));
      const editorialSource = preferred.length ? source.slice().sort((a,b) =>
        (positions.get(a.dataset.productHandle) ?? Infinity) - (positions.get(b.dataset.productHandle) ?? Infinity)) : source;
      for (const group of planEditorial(editorialSource.map(node => ({node,kind:node.dataset.editorialKind})))) {
        if (group.kind === 'study') {
          const node = group.items[0].node; node.classList.add('le-colour-slot');
          node.querySelector('.le-standard-card').hidden = true;
          node.querySelector('.le-study-content').hidden = false;
          node.querySelector('.le-colour-model img')?.classList.add('le-motion-photo');
          fragments.append(node);
        } else {
          const li = document.createElement('li'); li.className = 'le-editorial-row';
          const ul = document.createElement('ul'); ul.className = `le-editorial-grid le-group-${group.kind} le-count-${group.items.length}`;
          if (group.side) ul.dataset.featureSide = group.side;
          for (const item of group.items) {
            if (group.kind === 'feature' && item.kind === 'feature') {
              item.node.classList.add('le-model-feature');
              const photo=item.node.querySelector('.card__media img');
              if(photo){photo.classList.add('le-motion-photo');photo.dataset.leOriginalSizes=photo.sizes;photo.sizes='(max-width: 749px) calc(100vw - 32px), (min-width: 1440px) 660px, calc((100vw - 122px) / 2)';}
            }
            ul.append(item.node);
          }
          li.append(ul); fragments.append(li);
        }
      }
      grid.replaceChildren(fragments);
    }
    state.set(grid,{source,mode});
    document.querySelectorAll('.le-editorial-return').forEach(el => el.hidden = mode === 'editorial');
    grid.querySelectorAll('.le-model-feature .card__media,.le-colour-slot .le-colour-model').forEach(el => motion.observe(el));
  }
  const schedule = () => { if (!scheduled) {scheduled = true; requestAnimationFrame(refresh);} };
  function preservePreviewTemplate() {
    if (new URLSearchParams(location.search).get('view') !== 'featured-editorial') return;
    const back=document.querySelector('.le-editorial-return a');if(back){const url=new URL(back.href);url.searchParams.set('view','featured-editorial');back.href=url.href;}
    document.querySelectorAll('facet-filters-form form').forEach(form => {
      if (!form.querySelector('input[name="view"]')) {
        const input=document.createElement('input'); input.type='hidden';input.name='view';input.value='featured-editorial';form.append(input);
      }
    });
  }
  function start() {
    const container = document.getElementById('ProductGridContainer'); if (!container || !document.querySelector('.le-editorial-collection')) return;
    preservePreviewTemplate();refresh(); new MutationObserver(schedule).observe(container,{childList:true,subtree:true});
    document.addEventListener('le-seven:facet-grid-updated',()=>{preservePreviewTemplate();schedule();});
    document.addEventListener('input',event => {
      if (event.target.name === 'sort_by') customerSort = true;
      if (event.target.closest('facet-filters-form,[data-le-seven-filter]')) queueMicrotask(schedule);
    },true);
    window.addEventListener('popstate',()=>{customerSort=false;schedule();});
    document.addEventListener('visibilitychange',()=>document.body.classList.toggle('le-motion-paused',document.hidden));
    document.addEventListener('shopify:section:load',schedule);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start); else start();
})();
